import httpClient from '../../global/httpClient';
import qs from 'qs';

import * as apis from '../../constants/api';

export const postLoginBindMobile = payload =>
  httpClient.post(apis.LOGIN_BIND_MOBILE, qs.stringify(payload), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
